export default {
  dataApiConfig: {
    logging: {
      baseUrl: 'https://prod.core-gateway.api-business.comcast.com/logging-api',
      sensitiveFields: null,
    },
    invite: {
      baseUrl: 'https://invite-user.api-business.comcast.com',
      sensitiveFields: [
        'captchaToken',
        'emailAddress',
        'firstName',
        'lastName',
        'password',
        'securityAnswer',
        'securityQuestionDescription',
        'securityQuestionKey',
        'validationToken',
        'zipCode',
      ],
    },
  },
  //these info should be check again later with BE devs
  logContext: {
    appName: 'PrimaryInvite',
    appType: 'ClientApp',
    appVersion: process.env.REACT_APP_UI_VERSION,
    applicationId: 'invite-user-ui',
    apiKey: 'S8q4MNg7oL4k7Haq3LLKualLcAbfZULv2wcqYBUx',
    environment: 'prod',
  },
  sessionDurationInMinutes: 20,
  globalNavConfig: {
    scriptUrl:
      'https://bsd-global-nav-ui-prod-va.digital.business.comcast.com/globalNav.js',
    environment: 'prod',
  },
};
